import BaseEnum from './base-enum';

export default BaseEnum.create({
  values: [{ value: 1, label: 'Cloudflare Stream' }],
});
